import { Clock, MapPin, Navigation, Phone } from "lucide-react";
import { CLINIC } from "@/data/clinic";
import Reveal from "./Reveal";

export default function FindUs() {
    return (
        <section id="find-us" data-testid="find-us-section" className="bg-forest py-20 md:py-32">
            <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">
                        Find Us in Kurnool
                    </p>
                    <h2 className="mt-4 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-cream md:text-5xl" data-testid="find-us-heading">
                        {CLINIC.name}
                    </h2>
                    <p className="mt-6 text-sm leading-relaxed text-cream/80 md:text-base" data-testid="find-us-address">
                        {CLINIC.addressLines.map((l, i) => (
                            <span key={i} className="block">
                                {l}
                            </span>
                        ))}
                    </p>
                    <a
                        href={CLINIC.phoneTel}
                        className="mt-4 inline-flex items-center gap-2 font-serif text-2xl text-gold transition-colors duration-300 hover:text-cream"
                        data-testid="find-us-phone"
                    >
                        <Phone className="h-5 w-5" /> {CLINIC.phoneDisplay}
                    </a>
                    <p className="mt-3 flex items-center gap-2 text-sm text-cream/80" data-testid="find-us-hours">
                        <Clock className="h-4 w-4 text-gold" />
                        {CLINIC.hours.weekdays} &nbsp;•&nbsp; {CLINIC.hours.sunday}
                    </p>
                    <div className="mt-8 flex flex-wrap gap-4">
                        <a
                            href={CLINIC.mapsDirections}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="find-us-directions-btn"
                            className="inline-flex items-center gap-2 rounded-full bg-cream px-6 py-3 text-sm font-semibold text-ink transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold"
                        >
                            <Navigation className="h-4 w-4" /> Get Directions
                        </a>
                        <a
                            href={CLINIC.phoneTel}
                            data-testid="find-us-call-btn"
                            className="inline-flex items-center gap-2 rounded-full border border-cream/50 px-6 py-3 text-sm font-semibold text-cream transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-cream hover:bg-cream/10"
                        >
                            <Phone className="h-4 w-4" /> Call the Clinic
                        </a>
                    </div>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="overflow-hidden rounded-3xl border border-cream/15 shadow-2xl" data-testid="find-us-map">
                        <iframe
                            title="Agastya Chiro and Ancient Marma Therapy on Google Maps"
                            src={CLINIC.mapsEmbed}
                            className="h-[380px] w-full md:h-[440px]"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                        />
                    </div>
                    <p className="mt-4 inline-flex items-center gap-2 text-xs text-cream/60">
                        <MapPin className="h-3.5 w-3.5" /> Map and directions open the clinic's verified Google Business listing.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
